import {api} from 'services/api';
import {ResponseData} from 'types/response-data';
import queryParams from 'utils/query-params';

const getXLSExports = api.injectEndpoints({
  endpoints: builder => ({
    getXLSExports: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `export/pricing`,
          params: queryParams(params, '|'),
        };
      },
    }),
  }),
});

type Request = {};

type Response = ResponseData<{}>;

export const {useLazyGetXLSExportsQuery} = getXLSExports;
